/**
 * Attach all Handlebars helpers this way.
 */
import _ from 'underscore';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import HandlebarsIntl from 'handlebars-intl';
import hb_date_calendar from '@/views/helpers/date_calendar';
import hb_date_UTC from '@/views/helpers/date_UTC';
import hb_date_simple_UTC from '@/views/helpers/date_simple_UTC';
import hb_date_milli_UTC from '@/views/helpers/date_milli_UTC';
import hb_date_local from '@/views/helpers/date_local';
import hb_date_relative from '@/views/helpers/date_relative';
import hb_mac_address from '@/views/helpers/mac_address';
import hb_server_display_name from '@/views/helpers/server_display_name';
import hb_short_sha from '@/lib/short_sha';
import hb_if_equals from '@/views/helpers/if_equals';

export default function() {
    HandlebarsIntl.registerWith(Handlebars);
    // Render a template with data by passing in the template
    // selector and the data to render.

    // Render a template with data. The `template` parameter is
    // passed to the `TemplateCache` object to retrieve the
    // template function. Override this method to provide your own
    // custom rendering and template handling for all of Marionette.
    Marionette.Renderer.render = function render(template, data, view) {
        if (!template) {
            throw new Marionette.Error({
            name: 'TemplateNotFoundError',
            message: 'Cannot render the template since its false, null or undefined.'
            });
        }

        var templateFunc = _.isFunction(template) ? template : Marionette.TemplateCache.get(template);
        var options = view.templateOptions && _.clone(view.templateOptions);
        // Provide locale in the form of an array or string, if not
        // already provided by the view. handlebars-intl internally
        // converts a single string locale into an array.
        // navigator.languages gives a list of locale strings in order of
        // user preference (usually set at the OS or browser level).
        if (options) {
            if (options.data
                && options.data.intl
                && !options.data.intl.locales) {
                options.data.intl.locales =
                    navigator.languages || navigator.language;
            }
        }
        return templateFunc(data, view.templateOptions);
    };
    var helpers = [
        { name: 'date_calendar',          func: hb_date_calendar },
        { name: 'date_UTC',               func: hb_date_UTC },
        { name: 'date_simple_UTC',        func: hb_date_simple_UTC },
        { name: 'date_milli_UTC',         func: hb_date_milli_UTC },
        { name: 'date_local',             func: hb_date_local },
        { name: 'fmt_mac_address',        func: hb_mac_address },
        { name: 'server_display_name',    func: hb_server_display_name },
        { name: 'short_sha',              func: hb_short_sha },
        { name: 'date_relative',          func: hb_date_relative },
        { name: 'if_equals',              func: hb_if_equals },
    ], helper;

    for (var i = 0; i < helpers.length; i++) {
        helper = helpers[i];
        Handlebars.registerHelper(helper.name, helper.func);
    }
}

